import React from 'react';
import { ActionAlert } from '../salesRepDashboardTypes';
import styles from './ActionAlertsCard.module.css';

interface ActionAlertsCardProps {
  alerts: ActionAlert[];
}

export const ActionAlertsCard: React.FC<ActionAlertsCardProps> = ({ alerts }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>
          <span className={styles.headerIcon}>✨</span> AI Action Alerts
        </h3>
        <button className={styles.viewAll}>View All →</button>
      </div>
      <div className={styles.list}>
        {alerts.map((alert) => (
          <div key={alert.id} className={styles.alert}>
            <span className={styles.alertIcon}>📍</span>
            <div className={styles.body}>
              <p className={styles.customer}>{alert.customer}</p>
              <p className={styles.desc}>{alert.description}</p>
              <button className={styles.cta}>{alert.ctaLabel}</button>
            </div>
            <span className={styles.daysSince}>{alert.daysSince}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
